import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, resolveImageUrl } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Users, UserPlus } from "@phosphor-icons/react";

// Reusable dialog that lists followers / following of a member.
// `identifier` = user_id or slug, `type` = "followers" | "following"
export default function FollowListDialog({ open, onOpenChange, identifier, type, onNavigate }) {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open || !identifier) return;
    setLoading(true);
    api.get(`/members/${identifier}/${type}`)
      .then(r => setList(r.data))
      .catch(() => setList([]))
      .finally(() => setLoading(false));
  }, [open, identifier, type]);

  const title = type === "followers" ? "Seguidores" : "A seguir";
  const emptyMsg = type === "followers" ? "Ainda sem seguidores" : "Ainda não segue ninguém";

  function handleClick() {
    onOpenChange(false);
    onNavigate?.();
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#121217] border-white/10 text-white max-w-md max-h-[70vh] overflow-hidden flex flex-col" data-testid={`follow-list-dialog-${type}`}>
        <DialogHeader>
          <DialogTitle className="font-display text-xl flex items-center gap-2">
            {type === "followers" ? <Users size={20} weight="fill" /> : <UserPlus size={20} weight="fill" />}
            {title}
            <span className="text-sm font-mono-accent text-zinc-500">({list.length})</span>
          </DialogTitle>
        </DialogHeader>
        <div className="mt-2 overflow-y-auto -mx-2 px-2 space-y-1">
          {loading && (
            <div className="py-10 text-center text-zinc-500 font-mono-accent text-xs">A CARREGAR...</div>
          )}
          {!loading && list.length === 0 && (
            <div className="py-10 text-center text-zinc-500 font-mono-accent text-xs" data-testid={`follow-list-empty-${type}`}>{emptyMsg}</div>
          )}
          {!loading && list.map((m) => (
            <Link
              key={m.user_id}
              to={`/membros/${m.slug || m.user_id}`}
              onClick={handleClick}
              className="flex items-center gap-3 p-2 rounded-lg hover:bg-white/5 transition-colors"
              data-testid={`follow-list-item-${m.user_id}`}
            >
              {m.picture ? (
                <img src={resolveImageUrl(m.picture)} alt="" className="w-10 h-10 rounded-full object-cover border border-white/10" />
              ) : (
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#E63946] to-[#7209B7] grid place-items-center text-sm font-display font-bold">
                  {(m.name || "?")[0]?.toUpperCase()}
                </div>
              )}
              <span className="font-display font-semibold text-sm truncate">{m.name || "Sem nome"}</span>
            </Link>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
